import { render } from "./imageResizer.vue?vue&type=template&id=2a64f9cd&scoped=true"
import script from "./imageResizer.vue?vue&type=script&lang=js"
export * from "./imageResizer.vue?vue&type=script&lang=js"

import "./imageResizer.vue?vue&type=style&index=0&id=2a64f9cd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a64f9cd"]])

export default __exports__